import BuyerCards from "./BuyerCards";

export default BuyerCards;
